export default __webpack_public_path__ + "static/media/Female-3.6d379ebc.svg";